import { CartModification } from '@spartacus/cart/base/root';
import { GenNotification } from '../models/notification.model';
import {
  GenLimitedAvailabilityCheckoutError,
  GenLimitedAvailabilityItem,
} from '../models/limited-availability.model';

export const LIMITED_NO_AVAILABILITY = 'limitedNoAvailability';
export const LIMITED_NO_AVAILABILITY_ADD = 'limitedNoAvailability.add';
export const LIMITED_NO_AVAILABILITY_UPDATE = 'limitedNoAvailability.update';
export const LIMITED_PARTIAL_AVAILABILITY = 'limitedPartialAvailability';
export const LIMITED_QUANTITY_ADJUSTED = 'limitedQuantityAdjusted';
export const LIMITED_QUANTITY_ADJUSTED_CHECKOUT = 'limitedQuantityAdjusted.checkout';
export const LIMITED_AVAILABILITY_CHECKOUT_ERROR = 'LimitedAvailabilityCheckoutError';
export const LIMITED_AVAILABILITY_CHECKOUT_CONTINUE = 'continueAndPlaceOrder';
export const LIMITED_AVAILABILITY_CHECKOUT_REVIEW_CART = 'reviewCart';

export const LIMITED_AVAILABILITY_POPUP_CODES = [
  LIMITED_NO_AVAILABILITY_ADD,
  LIMITED_NO_AVAILABILITY_UPDATE,
  LIMITED_PARTIAL_AVAILABILITY,
];

export interface GenLimitedCartModification extends CartModification {
  availableInventory?: number;
  generacNotifications?: GenNotification[];
}

export function isLimitedAvailabilityStatus(statusCode?: string): boolean {
  return statusCode === LIMITED_NO_AVAILABILITY ||
    statusCode === LIMITED_PARTIAL_AVAILABILITY ||
    statusCode === LIMITED_QUANTITY_ADJUSTED ||
    statusCode === LIMITED_QUANTITY_ADJUSTED_CHECKOUT;
}

export function isLimitedAvailabilityCode(code?: string): boolean {
  return !!code && (
    LIMITED_AVAILABILITY_POPUP_CODES.includes(code) ||
    code === LIMITED_QUANTITY_ADJUSTED ||
    code === LIMITED_QUANTITY_ADJUSTED_CHECKOUT
  );
}

export function isLimitedAvailabilityCheckoutNotificationCode(code?: string): boolean {
  return code === LIMITED_QUANTITY_ADJUSTED_CHECKOUT ||
    code === LIMITED_NO_AVAILABILITY_UPDATE;
}

export function isLimitedAvailabilityCheckoutError(error?: GenLimitedAvailabilityCheckoutError): boolean {
  return error?.type === LIMITED_AVAILABILITY_CHECKOUT_ERROR;
}

export function findLimitedAvailabilityCheckoutError(error: any): GenLimitedAvailabilityCheckoutError | undefined {
  const errors = error?.error?.errors ?? error?.errors ?? error?.error?.details ?? error?.details;

  if (!Array.isArray(errors)) {
    return undefined;
  }

  return errors.find(isLimitedAvailabilityCheckoutError);
}

export function getLimitedAvailabilityNewQuantity(item: GenLimitedAvailabilityItem): number | undefined {
  return item.newQuantity ?? item.availableInventory;
}

export function getLimitedAvailabilityTitleKey(notification: GenNotification, isCartUpdated: boolean): string {
  if (isLimitedAvailabilityCheckoutError(notification)) {
    return 'limitedAvailability.checkoutModal.title';
  }

  if (notification.code === LIMITED_QUANTITY_ADJUSTED_CHECKOUT || isCartUpdated) {
    return 'limitedAvailability.cartUpdated.title';
  }

  return notification.code === LIMITED_PARTIAL_AVAILABILITY
    ? 'limitedAvailability.partial.title'
    : 'limitedAvailability.unavailable.title';
}

export function getLimitedAvailabilityIntroKey(notification: GenNotification, isCartUpdated: boolean): string {
  if (isLimitedAvailabilityCheckoutError(notification)) {
    return 'limitedAvailability.checkoutModal.inventoryChangedIntro';
  }

  if (notification.code === LIMITED_NO_AVAILABILITY_UPDATE) {
    return 'limitedAvailability.unavailable.updateIntro';
  }

  if (notification.code === LIMITED_QUANTITY_ADJUSTED_CHECKOUT || isCartUpdated) {
    return 'limitedAvailability.cartUpdated.intro';
  }

  if (notification.code === LIMITED_PARTIAL_AVAILABILITY) {
    return 'limitedAvailability.partial.intro';
  }

  return 'limitedAvailability.unavailable.addIntro';
}

export function getLimitedAvailabilityFooterKeys(notification: GenNotification, isCartUpdated: boolean): string[] {
  if (notification.code === LIMITED_QUANTITY_ADJUSTED_CHECKOUT || isCartUpdated) {
    return ['limitedAvailability.cartUpdated.footer'];
  }

  if (notification.code === LIMITED_PARTIAL_AVAILABILITY) {
    return ['limitedAvailability.partial.footer'];
  }


  const firstFooterKey = notification.code === LIMITED_NO_AVAILABILITY_UPDATE
    ? null
    : 'limitedAvailability.unavailable.addFooter';

  return [
    firstFooterKey,
    'limitedAvailability.unavailable.contactFooter',
  ];
}
